import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {exhaustMap, filter, Subject, Subscription} from 'rxjs';
import {LabInfo, FormData} from '@vasio-nl/skideo-create-lib';
import {TemplateEditMode} from 'src/app/views/builder/builder-form/builder-form.component';
import {TemplateService} from '../../services/template.service';
import {notNull} from '../../utils/utils';

export interface TemplateSaveContent {
  id: string;
  labInfo: LabInfo;
  createForm: UntypedFormGroup;
  dynamicFormValues: FormData;
}

@Component({
  selector: 'app-template-save',
  templateUrl: './template-save.component.html',
  styleUrls: ['./template-save.component.scss'],
  standalone: false,
})
export class TemplateSaveComponent implements OnInit, OnDestroy {
  modalContent: TemplateSaveContent | null = null;
  templateName = new UntypedFormControl(null, {validators: Validators.required});
  confirmSave$ = new Subject<TemplateSaveContent>();
  private subscriptions: Subscription[] = [];

  constructor(
    private templateService: TemplateService,
    private toastr: ToastrService,
    private router: Router,
    private bsModalRef: BsModalRef,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.confirmSave$
        .pipe(
          filter(() => this.templateName.valid),
          exhaustMap(({id, labInfo, createForm, dynamicFormValues}) =>
            this.templateService.createUpdateBuilderTemplate$(
              id,
              labInfo,
              createForm,
              TemplateEditMode.NEW,
              this.templateName.value,
              null,
              /* eslint-disable @typescript-eslint/no-explicit-any */
              dynamicFormValues as any,
            ),
          ),
        )
        .subscribe(templateItem => {
          this.toastr.success($localize`Template created!`);
          this.router.navigate(['templates', 'details', templateItem.id]);
          this.bsModalRef.hide();
        }),

      this.confirmSave$.subscribe(() => {
        this.templateName.updateValueAndValidity();
        if (this.templateName.invalid) {
          this.toastr.error($localize`Please enter a valid template name`);
        }
      }),
    );
  }

  confirm(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.confirmSave$.next(notNull(this.modalContent));
  }

  closeModal(): void {
    this.bsModalRef.hide();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
